<div class="componentMenu">
  <div class="screenItemWrapper">
    <div
      *ngFor="let item of componentOptions | async"
      [id]="item.type"
      draggable="true"
      (dragstart)="dragStartHandler($event)"
      (drop)="transferHandler($event)">
      <jha-button
        [jhaText]="item.name"
        jhaButtonStyle="Secondary"
        [jhaIconType]="item.icon"
        jhaButtonSize="Small">
      </jha-button>
    </div>
  </div>
  <jha-button
    [jhaIsDisabled]="removeIsDisabled"
    title="Delete"
    (jhaClick)="toggleDeleteComponentModal()"
    jhaIconType="Delete"
    jhaButtonStyle="Destructive"
    jhaButtonSize="Small"></jha-button>
</div>

<div *ngIf="viewData | async" class="stageHolder">
  <div
    #stageContainer
    id="stage"
    (dragover)="dragOverHandler($event)"
    (drop)="transferHandler($event)"
    (click)="stageSelectedHandler()"
    cdkDropList
    (cdkDropListDropped)="repositionHandler($event)"
    class="stage"
    [ngClass]="{ activeComponent: stageSelected }"
    [cdkDropListSortingDisabled]="true"
    [cdkDropListAutoScrollDisabled]="true"
    [ngStyle]="{
      height: stageInfo.stageHeight + 'px',
      width: '100%',
      maxWidth: stageInfo.stageWidth + 'px'
    }">
    <div *ngFor="let componentData of stageComponents">
      <div
        (click)="componentSelectedHandler($event, componentData.id)"
        (cdkDragStarted)="
          componentSelectedHandler($event.event, componentData.id)
        "
        class="stageElement"
        cdkDrag
        cdkDragBoundary=".stage"
        (cdkDragMoved)="dragged($event)"
        [id]="componentData.id"
        [ngClass]="{ activeComponent: componentData.id === activeComponentId }"
        [ngStyle]="{
          left: componentData.left + 'px',
          top: componentData.top + 'px',
          width: componentData.width + 'px',
          height: componentData.height + 'px',
          'text-align': componentData.textAlign
        }">
        <div style="pointer-events: none; box-sizing: border-box">
          <app-screen-button
            [initOptions]="componentData"
            *ngIf="componentData.type === ComponentType.Button">
          </app-screen-button>
          <app-screen-label
            [initOptions]="componentData"
            *ngIf="componentData.type === ComponentType.Label">
          </app-screen-label>
          <app-screen-anchor
            [initOptions]="componentData"
            *ngIf="componentData.type === ComponentType.Anchor">
          </app-screen-anchor>
          <app-screen-combobox
            [initOptions]="componentData"
            *ngIf="componentData.type === ComponentType.ComboBox">
          </app-screen-combobox>
          <app-screen-checkbox
            [initOptions]="componentData"
            *ngIf="componentData.type === ComponentType.Checkbox">
          </app-screen-checkbox>
          <app-screen-image
            [initOptions]="componentData"
            *ngIf="componentData.type === ComponentType.Image">
          </app-screen-image>
          <app-screen-line
            [initOptions]="componentData"
            *ngIf="componentData.type === ComponentType.Line">
          </app-screen-line>
          <app-screen-radio
            [initOptions]="componentData"
            *ngIf="componentData.type === ComponentType.Radio">
          </app-screen-radio>
          <app-screen-input
            [initOptions]="componentData"
            *ngIf="componentData.type === ComponentType.Input">
          </app-screen-input>
        </div>

        <!-- Resize handles - only show when component is active -->
        <div
          *ngIf="componentData.id === activeComponentId"
          class="resize-handles">
          <!-- Corner handles -->
          <div
            class="resize-handle resize-nw"
            (mousedown)="startResize($event, componentData.id, 'nw')"
            title="Resize"></div>
          <div
            class="resize-handle resize-ne"
            (mousedown)="startResize($event, componentData.id, 'ne')"
            title="Resize"></div>
          <div
            class="resize-handle resize-sw"
            (mousedown)="startResize($event, componentData.id, 'sw')"
            title="Resize"></div>
          <div
            class="resize-handle resize-se"
            (mousedown)="startResize($event, componentData.id, 'se')"
            title="Resize"></div>

          <!-- Edge handles -->
          <div
            class="resize-handle resize-n"
            (mousedown)="startResize($event, componentData.id, 'n')"
            title="Resize"></div>
          <div
            class="resize-handle resize-s"
            (mousedown)="startResize($event, componentData.id, 's')"
            title="Resize"></div>
          <div
            class="resize-handle resize-e"
            (mousedown)="startResize($event, componentData.id, 'e')"
            title="Resize"></div>
          <div
            class="resize-handle resize-w"
            (mousedown)="startResize($event, componentData.id, 'w')"
            title="Resize"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<jha-dialog-box
  jhaTitle="Delete Component"
  [(jhaShowDialog)]="isDeleteComponentModalShown"
  (jhaClose)="deleteFieldHandler($event)">
  <p>Are you sure you want to delete the selected component from your page?</p>
  <jha-dialog-box-button
    id="delete-ok"
    jhaText="Delete"
    jhaButtonStyle="Destructive"></jha-dialog-box-button>
  <jha-dialog-box-button
    id="delete-cancel"
    jhaText="Cancel"></jha-dialog-box-button>
</jha-dialog-box>
